import { render, staticRenderFns } from "./InvestReport.vue?vue&type=template&id=6570cebd&scoped=true&"
import script from "./InvestReport.vue?vue&type=script&lang=js&"
export * from "./InvestReport.vue?vue&type=script&lang=js&"
import style0 from "./InvestReport.vue?vue&type=style&index=0&id=6570cebd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6570cebd",
  null
  
)

export default component.exports